/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.Data
 */

module.exports = {

    DataManager: require('./DataManager'),
    DataManagerPlugin: require('./DataManagerPlugin')

};



//////////////////
// WEBPACK FOOTER
// ./data/index.js
// module id = 486
// module chunks = 0